import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import WarRoomCommentCreateFormEditor from '@/components/partials/war-room/WarRoomCommentCreateForm/WarRoomCommentCreateFormEditor.vue';
import SendIconSvg from '@/components/partials/war-room/WarRoomCommentCreateForm/images/send-comment.vue.svg';
import { dropRedundantWhitespace } from '@/components/partials/war-room/utils';

type WarRoomCommentCreateFormProps = {
  autofocus?: boolean;
  nested?: boolean;
  upserting?: boolean;
  initialText?: string;
  boostUsernames?: string[];
};
type WarRoomCommentCreateFormEmits = {
  (event: 'mounted' | 'cancel'): void;
  (event: 'post-comment', payload: { text: string; media: string | null; is_anonymous: boolean | null }): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomCommentCreateForm',
  props: {
    autofocus: { type: Boolean, default: false },
    nested: { type: Boolean, default: false },
    upserting: { type: Boolean, default: false },
    initialText: { default: '' },
    boostUsernames: { default: () => [] }
  },
  emits: ["mounted", "cancel", "post-comment"],
  setup(__props: any, { expose, emit }: { emit: ({
  (event: 'mounted' | 'cancel'): void;
  (event: 'post-comment', payload: { text: string; media: string | null; is_anonymous: boolean | null }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { autofocus: boolean, nested: boolean, upserting: boolean, initialText: string, boostUsernames: string[] };




onMounted(() => {
  emit('mounted');
});

const text = ref('');
const is_anonymous = ref<boolean | null>(null);
const imageKey = ref<string | null>(null);
const imageMedia = ref<string | null>(null);
const imageUploading = ref(false);
const profileLoaded = ref(false);
const editor = ref<HTMLElement | null>(null);

const isTextEmpty = computed(() => !text.value.replace(/&nbsp;|<br>/g, '').trim().length);
const rootClasses = computed(() => ({
  'war-room-comment-create-form': true,
  'war-room-comment-create-form--nested': props.nested,
}));
const isButtonDisabled = computed(
  () => isTextEmpty.value || props.upserting || imageUploading.value || !profileLoaded.value,
);

function handlePostComment() {
  if (isTextEmpty.value || imageUploading.value) {
    return;
  }
  emit('post-comment', {
    text: dropRedundantWhitespace(text.value),
    media: imageMedia.value,
    is_anonymous: is_anonymous.value,
  });
  clearEditor();
}

function handleTextChange(t: string) {
  text.value = t;
}

function handleIsAnonymousChange({ isAnonymous, loaded }: { isAnonymous: boolean; loaded: boolean }) {
  is_anonymous.value = isAnonymous;
  profileLoaded.value = loaded;
}

function handleImageChange({ key, media }: { key: string | null; media: string | null }) {
  imageKey.value = key;
  imageMedia.value = media;
}

function handleImageRemove() {
  handleImageChange({ key: null, media: null });
}

function handleImageUploading(state: boolean) {
  imageUploading.value = state;
}

function cancelComment() {
  emit('cancel');
}

// the following functions are exposed to parent components and are not used here
/* eslint-disable */
function focusEditor() {
  // @ts-expect-error
  editor.value?.focusInput();
}

function clearEditor() {
  // @ts-expect-error
  editor.value?.clearEditor();
}

function setText(text: string) {
  // @ts-expect-error
  editor.value?.setHTML(text);
}

/* eslint-enable */
expose({
  focusEditor,
  clearEditor,
  setText,
});

return { __sfc: true,props, emit, text, is_anonymous, imageKey, imageMedia, imageUploading, profileLoaded, editor, isTextEmpty, rootClasses, isButtonDisabled, handlePostComment, handleTextChange, handleIsAnonymousChange, handleImageChange, handleImageRemove, handleImageUploading, cancelComment, focusEditor, clearEditor, setText, BravadoButtonV3, WarRoomCommentCreateFormEditor, SendIconSvg }
}

})